import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../../mutation-types';
import CrmLossReasonsAPI from '../../../api/crm/lossReasons';

export const state = {
    records: [],
    uiFlags: {
        isFetching: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
    },
};

export const getters = {
    getUIFlags(_state) {
        return _state.uiFlags;
    },
    getLossReasons(_state) {
        return _state.records;
    },
    getLossReasonById: _state => id => {
        return _state.records.find(r => r.id === Number(id));
    },
};

export const actions = {
    get: async ({ commit }) => {
        commit(types.SET_CRM_LOSS_REASONS_UI_FLAG, { isFetching: true });
        try {
            const response = await CrmLossReasonsAPI.get();
            commit(types.SET_CRM_LOSS_REASONS, response.data);
        } catch (error) {
            // Ignore error
        } finally {
            commit(types.SET_CRM_LOSS_REASONS_UI_FLAG, { isFetching: false });
        }
    },
    create: async ({ commit }, lossReasonObj) => {
        commit(types.SET_CRM_LOSS_REASONS_UI_FLAG, { isCreating: true });
        try {
            const response = await CrmLossReasonsAPI.create(lossReasonObj);
            commit(types.ADD_CRM_LOSS_REASON, response.data);
            return response.data;
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_LOSS_REASONS_UI_FLAG, { isCreating: false });
        }
    },
    update: async ({ commit }, { id, ...updateObj }) => {
        commit(types.SET_CRM_LOSS_REASONS_UI_FLAG, { isUpdating: true });
        try {
            const response = await CrmLossReasonsAPI.update(id, updateObj);
            commit(types.EDIT_CRM_LOSS_REASON, response.data);
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_LOSS_REASONS_UI_FLAG, { isUpdating: false });
        }
    },
    delete: async ({ commit }, id) => {
        commit(types.SET_CRM_LOSS_REASONS_UI_FLAG, { isDeleting: true });
        try {
            await CrmLossReasonsAPI.delete(id);
            commit(types.DELETE_CRM_LOSS_REASON, id);
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_LOSS_REASONS_UI_FLAG, { isDeleting: false });
        }
    },
};

export const mutations = {
    [types.SET_CRM_LOSS_REASONS_UI_FLAG](_state, data) {
        _state.uiFlags = { ..._state.uiFlags, ...data };
    },
    [types.SET_CRM_LOSS_REASONS]: MutationHelpers.set,
    [types.ADD_CRM_LOSS_REASON]: MutationHelpers.create,
    [types.EDIT_CRM_LOSS_REASON]: MutationHelpers.update,
    [types.DELETE_CRM_LOSS_REASON]: MutationHelpers.destroy,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
